// #region Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Formik } from "formik";
import * as yup from "yup";

//FluentUI
import { Stack } from "office-ui-fabric-react/lib/Stack";
import {
  DetailsListLayoutMode,
  SelectionMode,
  Selection,
  IColumn,
} from "office-ui-fabric-react/lib/DetailsList";
import { ShimmeredDetailsList } from "office-ui-fabric-react/lib/ShimmeredDetailsList";
import { CommandBarButton, ICommandBarStyles } from "office-ui-fabric-react";
import { IDialogContentProps } from "office-ui-fabric-react/lib/Dialog";
//MaterialUI
//Componentes
import Panel from "~/components/layout/Panel";
import Status from "~/components/Status";
import CustomDialog from "~/components/CustomDialogFluentUI";
import { InputText, InputCheckbox } from "~/components/Forms";
import HeaderPage from "~/components/layout/HeaderPage";
import NoItems from "~/components/layout/NoItems";
import { DeleteButton } from "~/components/Buttons";
import { Page, BreadcrumbItems } from "~/store/ducks/home/types";
//Estilos
import {
  Wrapper,
  ListContainer,
  DefaultButton,
  ContainerContent,
} from "./styles";

import { PrimaryButton } from "~/components/Buttons";
import { Creators as getConducts } from "~/store/ducks/admin/conducts";
import { Creators as addConduct } from "~/store/ducks/admin/conducts";
import { Creators as delConduct } from "~/store/ducks/admin/conducts";
import { Creators as editConduct } from "~/store/ducks/admin/conducts";
import { Creators as setCurrentPage } from "~/store/ducks/home";
import { ConductType, DataTypes } from "~/store/ducks/admin/conducts/types";
import { Creators as getTypeConducts } from "~/store/ducks/admin/typeConducts";
import { DataTypes as DataTypesTypeConducts } from "~/store/ducks/admin/typeConducts/types";
import { Creators as getSanctions } from "~/store/ducks/admin/sanctions";
import { DataTypes as DataTypesSanctions } from "~/store/ducks/admin/sanctions/types";
import { RootState } from "~/store/ducks";
import Dropdown from "~/components/layout/Dropdown";
import { MenuItem } from "@material-ui/core";
//#endregion

const btnStyle: Partial<ICommandBarStyles> = {
  root: {
    height: 44,
  },
};

/**
 * Validação do formulário
 */
const validationConductSchema = yup.object().shape({
  titulo: yup.string().required("Campo obrigatório"),
  gravidade: yup.string().required("Campo obrigatório"),
  idTipoConduta: yup.number().nullable().required("Campo obrigatório"),
  idSancao: yup.number().nullable().required("Campo obrigatório"),
  flagAtivo: yup.bool(),
});

interface IConductsState {
  columns: IColumn[];
  items: ConductType[];
  isPanelOpen: boolean;
  inicialValues: ConductType;
  isFiltering: boolean;
  selectionDetails: string;
  selectionCount: number;
  isDialogExcludeOpen: boolean;
}

interface IPropsConducts {
  conducts: DataTypes;
  typesConducts: DataTypesTypeConducts;
  sanctions: DataTypesSanctions;
  setCurrentPage: (page: Page) => void;
  getConducts: () => void;
  getTypeConducts: () => void;
  getSanctions: () => void;
  addConduct: (conduct: ConductType) => void;
  editConduct: (conduct: ConductType) => void;
  delConduct: (id: number) => void;
}

const itemsBreadCrumb: BreadcrumbItems[] = [
  {
    text: "Home",
    isCurrentItem: false,
    icon: "HomeSolid",
    onlyIcon: true,
    url: "/",
  },
  { text: "Condutas", isCurrentItem: true },
];

const initialValue: ConductType = {
  idConduta: null,
  idSancao: null,
  idTipoConduta: null,
  gravidade: "",
  titulo: "",
  sancao: {
    descSancao: "",
  },
  tipoConduta: {
    titulo: "",
  },
  flagAtivo: true,
};

class Conducts extends Component<IPropsConducts, IConductsState> {
  private formRef: any;
  private _selection: Selection;

  constructor(props: IPropsConducts) {
    super(props);
    //#region Colunas
    const columns: IColumn[] = [
      {
        key: "column1",
        name: "",
        ariaLabel: "Status da Conduta",
        fieldName: "flagAtivo",
        minWidth: 15,
        maxWidth: 20,
        isResizable: true,
        isSortedDescending: false,
        onRender: (item: ConductType) => <Status status={item.flagAtivo} />,
      },
      {
        key: "column2",
        name: "ID",
        ariaLabel: "Id da Conduta",
        fieldName: "idConduta",
        isRowHeader: true,
        minWidth: 75,
        maxWidth: 100,
        isResizable: true,
        isSortedDescending: false,
        onColumnClick: this._onColumnClick,
      },
      {
        key: "column3",
        name: "Tipo",
        fieldName: "tipoConduta.titulo",
        minWidth: 150,
        maxWidth: 200,
        isRowHeader: true,
        isResizable: true,
        isSorted: true,
        isSortedDescending: false,
        sortAscendingAriaLabel: "Sorted A to Z",
        sortDescendingAriaLabel: "Sorted Z to A",
        onColumnClick: this._onColumnClick,
        data: "string",
        isPadded: true,
        onRender: (item: ConductType) => item.tipoConduta.titulo,
      },
      {
        key: "column4",
        name: "Título",
        fieldName: "titulo",
        minWidth: 210,
        maxWidth: 350,
        isRowHeader: true,
        isResizable: true,
        isSorted: true,
        isSortedDescending: false,
        sortAscendingAriaLabel: "Sorted A to Z",
        sortDescendingAriaLabel: "Sorted Z to A",
        onColumnClick: this._onColumnClick,
        data: "string",
        isPadded: true,
      },
    ];
    //#endregion

    this.state = {
      columns: columns,
      items: [],
      isPanelOpen: false,
      selectionDetails: "",
      inicialValues: initialValue,
      isFiltering: false,
      selectionCount: 0,
      isDialogExcludeOpen: false,
    };

    this._selection = new Selection({
      onSelectionChanged: () => {
        this.setState({
          selectionDetails: this._getSelectionDetails(),
        });
      },
    });

    this.formRef = React.createRef();
  }

  componentDidMount() {
    const page: Page = {
      key: "condutas",
      pages: itemsBreadCrumb,
    };
    this.props.setCurrentPage(page);
    this.props.getConducts();
    this.props.getTypeConducts();
    this.props.getSanctions();
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (this.state.isPanelOpen) {
      if (prevProps.conducts.success !== this.props.conducts.success) {
        if (this.props.conducts.success) {
          this.setState({ isPanelOpen: false });
          this._selection.setAllSelected(false);
        }
      }
    }
  }

  // Submit do formulário Formik
  handleSubmit = () => {
    if (this.formRef.current) {
      this.formRef.current.handleSubmit();
    }
  };

  _onItemInvoked = (item: ConductType): void => {
    this.setState({
      isPanelOpen: true,
      inicialValues: {
        ...item,
      },
    });
  };

  _getSelectionDetails(): any {
    const selectionCount = this._selection.getSelectedCount();
    this.setState({ selectionCount });
    this._selection.getSelection();
  }

  openEdit = () => {
    const selectItem: ConductType = this._selection.getSelection()[0] as ConductType;
    this.setState({ isPanelOpen: true, inicialValues: selectItem });
  };

  cancelPanel = () => {
    this._selection.setAllSelected(false);
    this.setState({ isPanelOpen: false });
  };

  excludeConduct = () => {
    this.props.delConduct(
      (this._selection.getSelection()[0] as ConductType).idConduta!
    );
    this.setState({ isDialogExcludeOpen: false });
    this._selection.setAllSelected(false);
  };

  //#endregion

  commandBarRender = () => {
    const { selectionCount } = this.state;
    if (selectionCount === 1) {
      return (
        <>
          <CommandBarButton
            styles={btnStyle}
            iconProps={{ iconName: "Edit" }}
            text="Editar"
            onClick={() => this.openEdit()}
          />
          <CommandBarButton
            styles={btnStyle}
            iconProps={{ iconName: "Delete" }}
            text="Excluir"
            onClick={() => this.setState({ isDialogExcludeOpen: true })}
          />
        </>
      );
    } else if (selectionCount > 1) {
      return (
        <CommandBarButton
          styles={btnStyle}
          iconProps={{ iconName: "Delete" }}
          text="Excluir"
          onClick={() => this.setState({ isDialogExcludeOpen: true })}
        />
      );
    }
  };

  render() {
    const {
      isPanelOpen,
      isDialogExcludeOpen,
      selectionCount,
      inicialValues,
      isFiltering,
      items,
      columns,
    } = this.state;
    const {
      conducts,
      typesConducts,
      sanctions,
      addConduct,
      editConduct,
      getConducts,
    } = this.props;

    const dialogContentProps: IDialogContentProps = {
      title: "Excluir?",
      closeButtonAriaLabel: "Close",
      subText:
        selectionCount <= 1
          ? "Tem certeza de que deseja excluir este item?"
          : "Tem certeza de que deseja excluir estes items?",
    };

    return (
      <>
        <Panel
          title={
            !inicialValues.idConduta ? "Nova Conduta" : inicialValues.titulo
          }
          open={isPanelOpen}
          onClose={() => this.cancelPanel()}
          footer={
            <Stack horizontal tokens={{ childrenGap: 10 }}>
              <DefaultButton onClick={() => this.cancelPanel()}>
                Cancelar
              </DefaultButton>
              <PrimaryButton
                onClick={this.handleSubmit}
                isLoading={conducts.loadingAction}
                text="Salvar"
              />
            </Stack>
          }
        >
          <Formik
            innerRef={this.formRef}
            initialValues={{
              ...inicialValues,
              flagAtivo: !inicialValues.flagAtivo,
            }}
            validationSchema={validationConductSchema}
            validateOnChange={false}
            validateOnBlur={true}
            onSubmit={(values: ConductType) => {
              if (inicialValues.idConduta === null) {
                values.tipoConduta.titulo =
                  typesConducts.data.find(
                    (item) => item.idTipoConduta === values.idTipoConduta
                  )?.titulo ?? "";

                addConduct(values);
              } else {
                values.idConduta = inicialValues.idConduta;
                editConduct({ ...values, flagAtivo: !values.flagAtivo });
              }
            }}
          >
            {({
              handleSubmit,
              handleChange,
              values,
              errors,
              setFieldError,
            }) => (
              <form onSubmit={handleSubmit}>
                <InputText
                  value={values.titulo}
                  onChange={(e) => {
                    handleChange(e);
                    setFieldError("titulo", "");
                  }}
                  id="titulo"
                  error={errors.titulo ? true : false}
                  name="titulo"
                  type="text"
                  label="Título"
                  helperText={errors.titulo}
                  className="mt-2"
                  autoFocus
                />
                <Dropdown
                  errors={errors.idTipoConduta}
                  errorText={errors.idTipoConduta}
                  label="Tipo de Conduta"
                  name="idTipoConduta"
                  values={values.idTipoConduta ?? 0}
                  handleChange={(e: any) => {
                    handleChange(e);
                    setFieldError("idTipoConduta", "");
                  }}
                >
                  {typesConducts.data
                    .filter((tipo) => tipo.flagAtivo)
                    .map((tipo) => (
                      <MenuItem
                        key={tipo.idTipoConduta}
                        value={tipo.idTipoConduta!}
                      >
                        {tipo.titulo}
                      </MenuItem>
                    ))}
                </Dropdown>
                <Dropdown
                  errors={errors.gravidade}
                  errorText={errors.gravidade}
                  label="Gravidade"
                  name="gravidade"
                  values={values.gravidade}
                  handleChange={(e: any) => {
                    handleChange(e);
                    setFieldError("gravidade", "");
                  }}
                >
                  <MenuItem value="leve">Leve</MenuItem>
                  <MenuItem value="média">Média</MenuItem>
                  <MenuItem value="grave">Grave</MenuItem>
                  <MenuItem value="gravíssima">Gravíssima</MenuItem>
                </Dropdown>
                <Dropdown
                  errors={errors.idSancao}
                  errorText={errors.idSancao}
                  label="Sanção sugerida"
                  name="idSancao"
                  values={values.idSancao ?? ""}
                  handleChange={(e: any) => {
                    handleChange(e);
                    setFieldError("idSancao", "");
                  }}
                >
                  {sanctions.data
                    .filter((sancao) => sancao.flagAtivo)
                    .map((sancao) => (
                      <MenuItem key={sancao.idSancao} value={sancao.idSancao!}>
                        {sancao.descSancao}
                      </MenuItem>
                    ))}
                </Dropdown>
                {inicialValues.idConduta && (
                  <InputCheckbox
                    checked={values.flagAtivo}
                    onChange={handleChange}
                    name="flagAtivo"
                    color="primary"
                    label="Inativar Conduta"
                  />
                )}
              </form>
            )}
          </Formik>
        </Panel>

        <CustomDialog
          hidden={!isDialogExcludeOpen}
          onDismiss={() => this.setState({ isDialogExcludeOpen: false })}
          dialogContentProps={dialogContentProps}
        >
          <DefaultButton
            onClick={() => this.setState({ isDialogExcludeOpen: false })}
            text="Cancelar"
          />
          <DeleteButton onClick={() => this.excludeConduct()} text="Excluir" />
        </CustomDialog>
        <Wrapper>
          <ContainerContent>
            <HeaderPage
              title="Condutas"
              leftItems={
                <>
                  <CommandBarButton
                    styles={btnStyle}
                    iconProps={{ iconName: "Add" }}
                    disabled={conducts.loading}
                    text="Adicionar Conduta"
                    onClick={() =>
                      this.setState({
                        isPanelOpen: true,
                        inicialValues: initialValue,
                      })
                    }
                  />
                  {this.commandBarRender()}
                </>
              }
              rightItems={
                <CommandBarButton
                  styles={btnStyle}
                  iconProps={{ iconName: "Refresh" }}
                  text="Atualizar"
                  onClick={() => getConducts()}
                />
              }
            />
            {!conducts.loading && conducts.data.length === 0 ? (
              <NoItems
                error={conducts.error}
                text="Não há condutas cadastradas"
                img="/static/icons/supermarket.svg"
                alt="Condutas"
              />
            ) : (
              <ListContainer>
                <ShimmeredDetailsList
                  items={isFiltering ? items : conducts.data}
                  enableShimmer={conducts.loading}
                  columns={columns}
                  selectionMode={SelectionMode.single}
                  selection={this._selection}
                  getKey={this._getKey}
                  selectionPreservedOnEmptyClick={true}
                  setKey="single"
                  layoutMode={DetailsListLayoutMode.justified}
                  isHeaderVisible={true}
                  onItemInvoked={this._onItemInvoked}
                />
              </ListContainer>
            )}
          </ContainerContent>
        </Wrapper>
      </>
    );
  }

  private _onColumnClick = (
    ev: React.MouseEvent<HTMLElement>,
    column: IColumn
  ): void => {
    const { columns } = this.state;
    const newColumns: IColumn[] = columns.slice();
    let items: ConductType[] = [];
    if (this.state.isFiltering) {
      items = this.state.items;
    } else {
      items = this.props.conducts.data;
    }
    const currColumn: IColumn = newColumns.filter(
      (currCol) => column.key === currCol.key
    )[0];
    newColumns.forEach((newCol: IColumn) => {
      if (newCol === currColumn) {
        currColumn.isSortedDescending = !currColumn.isSortedDescending;
        currColumn.isSorted = true;
      } else {
        newCol.isSorted = false;
        newCol.isSortedDescending = true;
      }
    });
    const newItems = this._sort(
      items,
      currColumn.fieldName!,
      currColumn.isSortedDescending
    );
    this.setState({
      columns: newColumns,
      items: newItems,
    });
  };

  private _getKey(item: any, index?: number): any {
    if (item !== undefined) return item.key;
  }

  private _sort<T>(
    items: T[],
    columnKey: string,
    isSortedDescending?: boolean
  ): T[] {
    const result = (prop: string, obj: T) =>
      prop.split(".").reduce((a: any, b: any) => a[b] ?? "", obj);
    return items.sort((a: T, b: T) =>
      (
        isSortedDescending
          ? result(columnKey, a) < result(columnKey, b)
          : result(columnKey, a) > result(columnKey, b)
      )
        ? 1
        : -1
    );
  }
}
const mapStateToProps = (state: RootState) => ({
  conducts: state.conductsReducer,
  typesConducts: state.typeConductReducer,
  sanctions: state.sanctionReducer,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      ...getConducts,
      ...addConduct,
      ...delConduct,
      ...editConduct,
      ...setCurrentPage,
      ...getTypeConducts,
      ...getSanctions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Conducts);
